import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { trackConversion } from "@/lib/trackConversion";
import { useAuth } from "@/hooks/useAuth";

const NAMES = [
  { name: "Marco", city: "Roma" },
  { name: "Sarah", city: "London" },
  { name: "Ahmed", city: "Dubai" },
  { name: "Yuki", city: "Tokyo" },
  { name: "Anna", city: "Berlin" },
  { name: "James", city: "New York" },
  { name: "Lena", city: "Stockholm" },
  { name: "Carlos", city: "Madrid" },
  { name: "Sophie", city: "Paris" },
  { name: "David", city: "Sydney" },
  { name: "Marta", city: "Warsaw" },
  { name: "Omar", city: "Istanbul" },
  { name: "Elena", city: "Milano" },
  { name: "Lucas", city: "São Paulo" },
  { name: "Priya", city: "Mumbai" },
];

const randomMinutes = () => Math.floor(Math.random() * 12) + 1;

const RecentPurchaseToast = () => {
  const { isPremium } = useAuth();
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState({ name: "", city: "", minutes: 0 });

  useEffect(() => {
    if (isPremium) return;

    const showToast = () => {
      const person = NAMES[Math.floor(Math.random() * NAMES.length)];
      setCurrent({ ...person, minutes: randomMinutes() });
      setVisible(true);
      trackConversion("fomo_toast_shown");
      setTimeout(() => setVisible(false), 4000);
    };

    // First toast after 90-150 seconds
    const initial = setTimeout(showToast, (90 + Math.random() * 60) * 1000);

    // Recurring every 3-6 minutes (drastically reduced from 35-70s)
    const interval = setInterval(showToast, (180 + Math.random() * 180) * 1000);

    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, [isPremium]);

  if (isPremium) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ x: -300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -300, opacity: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 25 }}
          className="fixed bottom-20 left-4 z-50 flex items-center gap-2.5 rounded-lg border border-border bg-card px-3.5 py-2.5 shadow-lg max-w-[280px]"
        >
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-500/15">
            <ShieldCheck className="h-4 w-4 text-green-500" />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-semibold text-foreground truncate">
              {current.name} from {current.city}
            </p>
            <p className="text-[10px] text-muted-foreground">
              subscribed {current.minutes} min ago
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RecentPurchaseToast;
